import { inject, Pipe, PipeTransform } from '@angular/core';
import { HTMLCleanerService } from '@shared/modules/rich-editor/services/html-cleaner.service';

@Pipe({
  standalone: false,
  name: 'blankLinks',
})
export class BlankLinksPipe implements PipeTransform {
  private readonly htmlCleanerService = inject(HTMLCleanerService);

  transform(html: string): string {
    return html ? this.htmlCleanerService.clear(html) : '';
  }
}
